import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import store from "src/store";
import reportWebVitals from './reportWebVitals';

const AppComponent = React.lazy(() => import("./App"));

const rootElement = document.getElementById("root");
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);

  root.render(
    <HelmetProvider>
      <Provider store={store}>
        <Suspense fallback={null}>
          <AppComponent />
        </Suspense>
      </Provider>
    </HelmetProvider>
  );
}
reportWebVitals();


